import { Dialog } from '@mui/material';
import { type ConnectedProps, connect } from 'react-redux';
import { type RootState } from '@/store';
import { isModalOpen, selectCurrentModal, closeModal } from '../state';
import { getModalContent } from './getModalContent';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Modal = ({ isModalOpen, currentModal, closeModal }: Props) => {
  if (!currentModal) return null;
  const { modalType, modalData } = currentModal;
  const ModalContent = getModalContent(modalType);

  const handleClose = () => {
    closeModal();
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      closeAfterTransition={false}
      slotProps={{
        paper: {
          sx: styles.paper,
        },
      }}
    >
      <ModalContent closeModal={handleClose} modalData={modalData} />
    </Dialog>
  );
};

const connector = connect(
  (state: RootState) => ({
    isModalOpen: isModalOpen(state),
    currentModal: selectCurrentModal(state),
  }),
  { closeModal },
);

export default connector(Modal);
